/**
 * This script scans the page for links with no classes and adds a special class
 * to them to apply styling which overrides the bootstrap style.
 * 
 * It's crucial not to do this in CSS with an !important tag as this may cause
 * unexpected changes across the site due to the disrupted hierarchy
 */
export default {
  init() {

  },
  finalize() {
    $('p a').each(function() {
      if ($(this).get()[0].classList.length == 0) {
        $(this).addClass('default-link');
      }
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/defaultLinks.js